export default {
    OTPModelBuilder: function() {
        this.otpModel = new OTPModel();

        this.create = () => {
            return this.otpModel;
        };
    },
    AuthRequestOTPConfigModelBuilder: function() {
        this.authRequestOTPConfigModel = new AuthRequestOTPConfigModel();

        this.create = () => {
            return this.authRequestOTPConfigModel;
        };
    },
    OTPTimerModelBuilder: function() {
        this.otpTimerModel = new OTPTimerModel();

        this.create = () => {
            return this.otpTimerModel;
        };
    },
    OTPErrorModelBuilder: function() {
        this.otpErrorModel = new OTPErrorModel();

        this.create = () => {
            return this.otpErrorModel;
        };
    }



}

export function OTPModel() {
    this.display_contact_number = "";
    this.contact_number = "";
    this.otp = "";
    this.refcode = "";
    this.isShowResendOTP = false;
    this.expireTime = "";
}

export function OTPTimerModel() {
    this.numExpireIn = 0;
    this.numExpireDate = 0;
    this.numCurrentDate = 0;
    this.numOriginalStartDate = 0;
    this.isTimeRunning = false;
    this.isTimeExpired = false;
    this.time_left = "";
}

export function OTPErrorModel(isShowError, strMessage) {
    this.isShowError = isShowError || false;
    this.strMessage = strMessage || '';
}

export function AuthRequestOTPConfigModel(strContactNumber, strUuid, strChannel) {
    this.strContactNumber = strContactNumber || '';
    this.strUuid = strUuid || '';
    this.strChannel = strChannel || '';

    this.getParam = function () {
        var param = {};

        if (this.strContactNumber)
            param.contact_number = this.strContactNumber;

        if (this.strUuid)
            param.uuid = this.strUuid;

        if (this.strChannel)
            param.channel = this.strChannel;

        return param;
    }
}

